<template>
	
		<mapbase 
		:mapColor="mapColor" 
		:mapTitle="mapTitle" 
		:mapName="mapName" 
		:unit="unit" 
		:pieces="pieces"
		:cityD="cityD"
		:provicesD="provicesD"
		/>
		<!-- <mapbase /> -->
	
</template>

<script>
	import mapbase from './mapbase.vue'
	import '../../static/js/provincePipeLength.js'
	import '../../static/js/cityPipeLength.js'
	export default {
		name: 'mapuse',
		components: {
			mapbase,
		},
		data(){
			return {
				cityD:cityPipeLength,
				provicesD:provincePipeLength,
				unit:'公里',
				mapName:'城市供水管道长度',
				mapTitle:'2018年城市供水管道长度地图(公里)',
				mapColor:['#fff', '#FFCCE1', '#F7A8C5', '#ED82AA', '#F45E90', '#D43B78','#C70063'],
				pieces:[
							{
								min: 19427.550001
							}, 
							{
								min: 10826.720001,
								max:19427.550000
							},
							{
								min: 4583.660001,
								max: 10826.720000
							},
							{
								min: 2312.420001,
								max:  4583.660000
							},
							{
								min: 1041.500001,
								max: 2312.420000
							},
							{
								min: 12.820000 ,
								max: 1041.500000
							},
							{
								min: 0,
								max: 12.820000
							}
							
						]
			}
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: calc(100vh - 200px);
		margin: auto;
		/* border: 2px solid aquamarine; */
	}
	
	.search{
		margin-right: 30px;
		text-align: right;
		margin-bottom: 20px;
	}
	.search .el-input{
		width:30%
	}
	@media screen and (max-width:600px) {
		.search .el-input{
			width:50%
		}
	}
</style>
